import { Title } from '../../Title';
import type { AlertTitleProps } from './AlertTitle.types';

export const AlertTitle = ({ typography = 'labelMdSemibold', ...otherProps }: AlertTitleProps) => (
  <Title typography={typography} {...otherProps} />
);
